import { createAction, props } from '@ngrx/store';
import { InheritedIraState } from '@store/reducers/inherited-ira/inherited-ira.reducer';

export const UpdateInheritedIraDecedentInfo = createAction(
  '[Inherited IRA] Update decedent info',
  props<{ payload: InheritedIraState }>(),
);
